import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ClientService from '../../../../Services/clientService';
import stringHelper from '../../../../Helpers/stringHelper';
import ErrorMessage from '../../../ErrorMessage';

export default class ClientSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    showSelectFilterAt: 10,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    ClientService.GetClientListSlim()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((client) => {
          optValues.push({
            label: client.name + stringHelper.toBracket(client.clientId),
            value: client.clientId,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CMC41');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
        showSelectFilterAt={this.props.showSelectFilterAt}
      />
    );
  }
}
